interface TagObj {
  nodeName: string;
}

function checkIfNodeNameExistsInSet(tagObjs: TagObj[], filterSet: Set<string>): boolean {
  const index = tagObjs.findIndex(({ nodeName }) => nodeName === 'img');

  if (index === -1) {
    return false;
  }

  return filterSet.has(tagObjs[index].nodeName);
}

function filterContentBasedOnCondition(content: Array<any>, filterSet: Set<string>) {
  return content.filter((item) => {
    // specific check for images based on different object structure
    if (item.props?.responsiveImageConfig) {
      const tagObjs = item.props.responsiveImageConfig.tagConfigs;
      if (checkIfNodeNameExistsInSet(tagObjs, filterSet)) {
        return true;
      }
    }

    // check for match of basic html tags
    if (filterSet.has(item.props?.nodeType)) {
      return true;
    }

    // check for match of specific entry types
    if (filterSet.has(item.props?.componentName)) {
      return true;
    }

    return false;
  });
}

// clone and selectively filter element content
function cloneAndFilterElement(element: ComponentContent, filterSet: Set<string>) {
  if (element.props?.body?.props?.content) {
    const clonedElement = JSON.parse(JSON.stringify(element));
    clonedElement.props.body.props.content = filterContentBasedOnCondition(
      clonedElement.props.body.props.content,
      filterSet
    );
    return clonedElement;
  }
  return element;
}

export default function filterContent(elements: ComponentContent[], filter?: string | string[]) {
  if (!filter || (Array.isArray(filter) && filter.length === 0)) {
    return elements;
  }

  const filterSet = new Set(typeof filter === 'string' ? [filter] : filter);

  return elements
    .map((el) => cloneAndFilterElement(el, filterSet))
    .filter((element) => element.props.body.props.content && element.props.body.props.content.length > 0);
}
